module.exports = __webpack_public_path__ + "img/chat-right-dots-fill.6a4dfee3.svg";